
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host{
  display:block;
  padding: 0.5rem;
}@media (min-width: 1440px) {:host {
    padding: 1rem;
  }
}

.heading-container.margin-bottom {
  margin-bottom: 1rem;
}

:host([full-bleed]) .grid-container {
  max-width: 100%;
  padding-left: 0px;
  padding-right: 0px;
}

:host([container-align]) .grid-container, :host([container-align='center']) .grid-container, :host([heading-align]) .heading-container, :host([heading-align='center']) .heading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

:host([container-align='left']) .grid-container, :host([heading-align='left']) .heading-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

:host([container-align='right']) .grid-container, :host([heading-align='right']) .heading-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

:host([row-background-color='transparent']) {
  border-radius: 0.5rem;
  background-color: var(--neutral-transparent);
  padding: 0.5rem;
}

@media (min-width: 1280px) {:host([row-background-color='transparent']) {
    padding: 1.5rem;
  }
}

@media (min-width: 1440px) {:host([row-background-color='transparent']) {
    padding: 2rem;
  }
}

:host([row-background-color='white']) {
  border-radius: 0.5rem;
  background-color: var(--neutral-white);
  padding: 0.5rem;
}

@media (min-width: 1280px) {:host([row-background-color='white']) {
    padding: 1.5rem;
  }
}

@media (min-width: 1440px) {:host([row-background-color='white']) {
    padding: 2rem;
  }
}

:host([row-background-color='blue']) {
  border-radius: 0.5rem;
  background-color: var(--blue-responsible-lighten-4);
  padding: 2rem;
}

@media (min-width: 1280px) {:host([row-background-color='blue']) {
    padding: 1.5rem;
  }
}

@media (min-width: 1440px) {:host([row-background-color='blue']) {
    padding: 2rem;
  }
}

:host([row-background-color='light-blue']) {
  border-radius: 0.5rem;
  background-color: var(--blue-responsible-lighten-5);
  padding: 2rem;
}

@media (min-width: 1280px) {:host([row-background-color='light-blue']) {
    padding: 1.5rem;
  }
}

@media (min-width: 1440px) {:host([row-background-color='light-blue']) {
    padding: 2rem;
  }
}

:host([row-background-color='gray']) {
  border-radius: 0.5rem;
  background-color: var(--gray-professional-lighten-4);
  padding: 2rem;
}

@media (min-width: 1280px) {:host([row-background-color='gray']) {
    padding: 1.5rem;
  }
}

@media (min-width: 1440px) {:host([row-background-color='gray']) {
    padding: 2rem;
  }
}

:host([row-background-color='green']) {
  border-radius: 0.5rem;
  background-color: var(--green-guarantee-lighten-4);
  padding: 2rem;
}

@media (min-width: 1280px) {:host([row-background-color='green']) {
    padding: 1.5rem;
  }
}

@media (min-width: 1440px) {:host([row-background-color='green']) {
    padding: 2rem;
  }
}

idb-heading {
  color: var(--blue-responsible-darken-2);
}

.grid-container outline-grid{
  width:100%;
}
`;